var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12a4 4 0 014-4V4a3 3 0 116 0v.25h3a.75.75 0 010 1.5h-3V8a4 4 0 014 4v7a4 4 0 01-4 4H9a4 4 0 01-4-4v-7zm10-2.5H9A2.5 2.5 0 006.5 12v7A2.5 2.5 0 009 21.5h6a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0015 9.5z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaning);
export default __webpack_public_path__ + "static/media/Cleaning.2ec4376dfeac2ccf5a41bd2621034936.svg";
export { ForwardRef as ReactComponent };